"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=e(require("styled-components")).default.section`
    position: relative;
    padding: 85px ${({theme:e})=>e.spacing.large} 59px;

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        padding: 114px ${({theme:e})=>e.spacing.large} 152px;
    }

    .inner {
        margin: 0 auto;
        padding: 0;
        display: grid;
        grid-row-gap: 18px;
        width: 100%;
    }

    header {
        h3 {
            margin: 0;
        }
    }

    .categories {
        margin: 0;
        padding: 0;
        list-style: none;
        display: grid;
        grid-row-gap: 8px;

        @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
            grid-row-gap: 25px;
        }

        .category {
            width: 100%;
            margin: 0;
            padding: 0;
        }
    }

    .accordion-item {
        border: solid 1px ${({theme:e})=>e.colors.grey[300]};
        border-radius: 5px;

        button {
            padding: 19px;
            background: ${({theme:e})=>e.colors.grey[200]};
            border-radius: 5px;

            p {
                font-size: 20px;
                font-weight: bold;
            }

            svg {
                path {
                    fill: ${({theme:e})=>e.colors.primary.dark};
                }
            }
        }

        .content {
            padding: 19px 19px 40px;
            border-top: 1px solid ${({theme:e})=>e.colors.grey[300]};

            @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
                padding: 26px 19px 42px;
            }
        }
    }
`;module.exports=i;
//# sourceMappingURL=styled.js.map
